import React from 'react'
import { SubscriptionFrom } from './SubscriptionFrom'

export const Subscription = () => {
    return (
        <div className="w-full flex flex-col justify-center items-center mt-4 overflow-hidden  px-4 bg-[--color-button-3] h-60">
            <div className='flex flex-col justify-center items-center w-full  xl:w-[--page-width] gap-4'>
                    <h4 className='text-xl md:text-2xl lg:text-3xl font-bold text-white text-center'>Trở thành Khách hàng thân thiết và nhận thưởng "cổ đông"</h4>
                    <p className='text-white  text-sm md:text-base text-center'>Nhận thông tin mới nhất về cửa hàng và các khuyến mãi đặc biệt qua E-mail.</p>
                    <SubscriptionFrom/>
            </div>
        </div>
    )
}
